module.exports = __webpack_public_path__ + "img/classBg.81aac805.png";